

import React, { useState } from "react";
import "./Foodclientmanagement.css";

import Foodclientlanding from './Foodclientlanding';
import Logisticsclientlanding from '../Logistics/Logisticsclientlanding';
import Engineeringservices from "./Engineeringservices"
/* ----------- data not used in the real time functionla variations its working in Main Company Component all the data has een adedd in the real time code ------------ */
const Company = () => {
  const tabs = [
    { id: 1, name: "FOOD & BEVERAGES", component: () => <Foodclientlanding title="FOOD& BEVERAGES" /> },
    { id: 2, name: "Logistics", component: () => <Logisticsclientlanding title="Company Structure" /> },
    { id: 3, name: "Engineering", component: () => <Engineeringservices title="Engineering" /> },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
   /* Default (Mobile first) – kuch change nahi */
   .company-scroll-container {
     position: static;
     background: #fff;
   }
 
   .company-buttons-row {
     display: flex;
     // gap: 10px;
     flex-wrap: wrap;
   }
 
   .company-button {
     padding: 8px 16px;
     border: none;
     background: #f0f0f0;
     cursor: pointer;
     border-radius: 6px;
     white-space: nowrap;
   }
 
   .company-button.active {
     background: #e66d33;
     color: #fff;
   }
 
   /* ✅ Desktop / Laptop only */
   @media (min-width: 769px) {
     .company-scroll-container {
       position: sticky;
       top: 0;
       z-index: 100;
       padding: 10px 0;
     }
   }
 `}</style>


      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};


export default Company; 